import { DefineComponentProps } from 'utils'

type FullScreenMinHeightProps = {
  bottomPadding?: number
  emptyAreaHeight?: number
}

export const FullScreenMinHeight = defineComponent<FullScreenMinHeightProps>({
  props: DefineComponentProps<FullScreenMinHeightProps>(['bottomPadding', 'emptyAreaHeight']),
  setup(props, { slots }) {
    const mountedRef = ref<HTMLDivElement>()

    const setMinHeight = () => {
      if (!mountedRef.value) return
      const rect = mountedRef.value.getBoundingClientRect()
      if (props.emptyAreaHeight) {
        mountedRef.value.style.minHeight = `${props.emptyAreaHeight}px`
      } else {
        mountedRef.value.style.minHeight = `calc(var(--page-height) - ${rect.top + 20 + (props.bottomPadding || 0)}px)`
      }
    }

    onMounted(() => {
      setMinHeight()
    })

    onUpdated(() => {
      setMinHeight()
    })

    return () => (
      <div class="full-screen-min-height" ref={mountedRef}>
        {slots.default?.()}
      </div>
    )
  },
})
